export default __webpack_public_path__ + "static/media/06.03d1eff5.jpg";